  function initOrderNoteUpdater(scope = document) {
    var citySelect = scope.querySelector("#city-select");
    var districtSelect = scope.querySelector("#district-select");
    var orderNoteInput = scope.querySelector('textarea[name="note"]');
    var checkoutButton = scope.querySelector('button[name="checkout"]');

    if (!citySelect || !districtSelect || !orderNoteInput || !checkoutButton) return;
    if (checkoutButton.dataset.orderNoteInitialized === "true") return;

    checkoutButton.dataset.orderNoteInitialized = "true";

    function getOrderNoteDialog() {
      return (
        scope.querySelector("cart-note-dialog") ||
        document.querySelector("cart-note-dialog")
      );
    }

    function openOrderNoteDialog() {
      var dialog = getOrderNoteDialog();
      if (!dialog) return;

      dialog.setAttribute("open", "");
      dialog.style.display = "block";
      dialog.style.transform = "translateY(0px)";

      var textarea =
        dialog.querySelector('textarea[name="note"]') ||
        dialog.querySelector("textarea");

      if (textarea) {
        setTimeout(function () {
          textarea.focus();
        }, 50);
      }
    }

    function updateOrderNote() {
      var selectedCity =
        citySelect.options[citySelect.selectedIndex] &&
        citySelect.options[citySelect.selectedIndex].text
          ? citySelect.options[citySelect.selectedIndex].text
          : "";

      var selectedDistrict =
        districtSelect.options[districtSelect.selectedIndex] &&
        districtSelect.options[districtSelect.selectedIndex].text
          ? districtSelect.options[districtSelect.selectedIndex].text
          : "";

      if (
        !selectedCity ||
        !selectedDistrict ||
        selectedCity === "-- Seçin --" ||
        selectedDistrict === "-- Seçin --"
      ) {
        return;
      }

      var cityDistrictJSON = JSON.stringify({
        il: selectedCity,
        "ilçe": selectedDistrict
      });

      var existingNote = orderNoteInput.value || "";
      var pattern = /{\s*"il":\s*"[^"]+",\s*"ilçe":\s*"[^"]+"\s*}/;
      var existingCityDistrict = existingNote.match(pattern);

      if (existingCityDistrict) {
        orderNoteInput.value = existingNote.replace(pattern, cityDistrictJSON);
      } else {
        orderNoteInput.value =
          existingNote + (existingNote ? " | " : "") + cityDistrictJSON;
      }

      orderNoteInput.dispatchEvent(new Event("change", { bubbles: true }));
      orderNoteInput.dispatchEvent(new Event("input", { bubbles: true }));
    }

    function isCheckoutDisabled() {
      return (
        checkoutButton.disabled ||
        checkoutButton.hasAttribute("disabled") ||
        checkoutButton.getAttribute("aria-disabled") === "true"
      );
    }

    checkoutButton.addEventListener("click", function (e) {
      if (isCheckoutDisabled()) {
        e.preventDefault();
        e.stopPropagation();
        openOrderNoteDialog();
        return;
      }

      updateOrderNote();
    });

    /*
      Disabled buttons usually do not fire click events.
      So we listen on the parent wrapper too.
    */
    var checkoutWrapper = checkoutButton.parentElement;
    if (checkoutWrapper) {
      checkoutWrapper.addEventListener("pointerdown", function (e) {
        if (!isCheckoutDisabled()) return;

        var rect = checkoutButton.getBoundingClientRect();
        var x = e.clientX;
        var y = e.clientY;

        var clickedOnButtonArea =
          x >= rect.left &&
          x <= rect.right &&
          y >= rect.top &&
          y <= rect.bottom;

        if (clickedOnButtonArea) {
          e.preventDefault();
          e.stopPropagation();
          openOrderNoteDialog();
        }
      });
    }

    citySelect.addEventListener("change", updateOrderNote);
    districtSelect.addEventListener("change", updateOrderNote);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initOrderNoteUpdater(document);

    var cartDrawer = document.querySelector(
      "cart-drawer, .cart-drawer, [data-cart-drawer]"
    );

    if (!cartDrawer) return;

    var observer = new MutationObserver(function () {
      initOrderNoteUpdater(cartDrawer);
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  });